import { auth } from '../firebase';
import nodeAxiosFirebase from './nodeAxiosFirebase';

export async function deviceSecurityAction(action, values = {}, { userId = auth.currentUser?.uid, signal } = {}) {
  if (!userId || auth.currentUser?.uid !== userId) throw new Error('ACCOUNT_CHANGED');
  const response = await nodeAxiosFirebase({
    url: 'users/device-security',
    body: { ...values, action },
    retry: false,
    options: { timeout: 15000 },
    signal,
    expectedUserId: userId,
  });
  if (auth.currentUser?.uid !== userId) throw new Error('ACCOUNT_CHANGED');
  if (response?.errorData) {
    const payload = response.errorData.data || {};
    throw Object.assign(new Error(payload.code || 'DEVICE_SECURITY_UNAVAILABLE'), {
      code: payload.code,
      retryAfter: payload.retryAfter,
      accountVerificationRecoveryRequired: payload.accountVerificationRecoveryRequired === true,
    });
  }
  const valid = action === 'list-devices' ? Array.isArray(response?.devices)
    : action === 'revoke-device' ? response?.success === true : typeof response?.verified === 'boolean';
  if (!valid) throw new Error('DEVICE_SECURITY_UNAVAILABLE');
  return response;
}

export function deviceSecurityError(error, t) {
  if ((error?.code || error?.message) === 'DEVICE_ACCOUNT_VERIFICATION_REQUIRED'
    && error.accountVerificationRecoveryRequired === true) return t('deviceSecurityAccountVerificationRecovery');
  const keys = {
    DEVICE_CODE_INVALID: 'deviceSecurityCodeInvalid',
    DEVICE_CODE_EXPIRED: 'deviceSecurityCodeExpired',
    DEVICE_CODE_LOCKED: 'deviceSecurityCodeLocked',
    DEVICE_RATE_LIMITED: 'deviceSecurityRateLimited',
    DEVICE_METHOD_UNAVAILABLE: 'deviceSecurityMethodUnavailable',
    DEVICE_ACCOUNT_VERIFICATION_REQUIRED: 'deviceSecurityAccountVerificationRequired',
    DEVICE_DELIVERY_FAILED: 'deviceSecurityDeliveryFailed',
    DEVICE_APPROVAL_REJECTED: 'deviceSecurityApprovalRejected',
    DEVICE_APPROVAL_EXPIRED: 'deviceSecurityCodeExpired',
  };
  return t(keys[error?.code || error?.message] || 'deviceSecurityUnavailable');
}
